class ListItem {
  constructor(document) {
    document = document || {}
    this.order = document.order || 0
    this.text = document.text || ''
  }
}

module.exports = ListItem
